// Angular Imports
import { ChangeDetectionStrategy, Component, input } from '@angular/core'
// Material Imports
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatIconModule } from '@angular/material/icon'

@Component({
	standalone: true,
	selector: 'app-info-tooltip',
	imports: [MatTooltipModule, MatIconModule],
	templateUrl: './info-tooltip.component.html',
	styleUrls: ['./info-tooltip.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoTooltipComponent {
	tooltipText = input.required<string>()
	tooltipPosition = input<'above' | 'below' | 'left' | 'right'>('above')
	iconColor = input<'white' | 'gray' | 'green' | 'black'>('white')
}

